<template>
  <div class="sectionTable resultados">
    <div class="row documento_dados_designacao" v-if="listItems.length > 0">
      <div class="hide-for-small-only small-12 medium-12 large-10 columns">
        <div class="row">
          <div class="small-12 medium-3 large-3 columns">
            <h3>{{ $t('avisoslist.referencia')  }}</h3>
          </div>
          <div class="small-12 medium-9 large-9 columns assunto_dados">
            <h3>{{ $t('avisoslist.descricao') }}</h3>
          </div>
        </div>
      </div>
      <div class="show-for-large large-2 columns data_vigor_dados">
        <h3>{{ $t('avisoslist.data') }}</h3>
      </div>
      <div class="show-for-small-only small-12 columns">
        <div class="row">
          <div class="small-12 columns">
            <h3>{{ $t('avisoslist.listadeavisos') }}</h3>
          </div>
        </div>
      </div>
    </div>
    <avisoitem 
      v-for="item in listItems" 
      :key="item.Ano"
      @click="chooseAviso(item)"
      :item="item" />
    <div class="row documento_dados" v-if="listItems.length == 0 && !fetching">
      <div class="small-12 medium-8 large-7 columns">
        <p>
          <img :src="errorIconUrl" class="icon_erro"> 
          {{ $t('avisoslist.semdoc') }}
        </p>
      </div>
    </div>
    <slot></slot>
  </div>
</template>

<script>
import avisoitem from './avisoitem.vue';
import { useRouter } from "vue-router";

export default {
  props:["listItems","fetching"],
  components:{
    avisoitem
  },
  setup(){
    const iconPdfUrl = 'https://www.uma.pt/wp-content/themes/uma/images/icon_pdf_cinza2.png';
    const errorIconUrl = 'https://www.uma.pt/wp-content/themes/uma/images/error_icon-29.png';

    const router = useRouter();

    const chooseAviso = aviso => {
      router.push(`/avisosecomunicados/${aviso.post_name}`);
    }

    return{
      chooseAviso,
      iconPdfUrl,
      errorIconUrl,
    }
  }
}

</script>

<style scoped>
/*#region Table Header*/
.documento_dados_designacao {
    border-bottom: 1px solid #a7a5a5;
}

.documento_dados_designacao .row .columns {
    padding-left: 0;
    padding-right: 0;
}

.documento_dados_designacao h3 {
  font-size: 12px;
  font-family: Montserrat;
  text-transform: uppercase;
  color: #707475;
}


@media (max-width: 1280px){
    .documento_dados_designacao h3 {
        font-size: 10px;
    }
}

@media (max-width: 1023px) {
    .anocolumn, .descolumn{
        display: none;
    }
}

@media (max-width: 767px){
    .inputwrapper {
        width: 100%;
    }
    .documento_dados .columns .columns {
        padding-bottom: 0px;
    }
    .documento_dados .row .columns:nth-of-type(2) {
        padding-right: 0px;
    }
    .documento_dados .columns .columns {
        padding-bottom: 0px;
    }
    .documento_dados .columns:first-of-type .columns:first-of-type h3 {
        margin-right: 10px;
    }
    .documento_dados h3 {
        padding-top: 6px;
    }
    .documento_dados h3 {
        font-size: 14px;
        padding-right: 0px;
        line-height: 1.6;
    }
}

/*#endregion Table Header*/

/*#region Table Body*/
.sectionTable .columns{
    padding-right: 0;
    padding-left: 0;
}

.icon_erro {
    width: 38px;
    margin-right: 10px;
    margin-bottom: 5px;
}

.documento_dados .columns p {
    font-size: 16px;
    font-family: "Montserrat Semibold";
    color: #707475;
    padding-top: 20px;
}

.documento_dados.tabledata .columns{
    padding-top: 21px;
    padding-bottom: 21px;
}

.documento_dados {
    border-bottom: 1px solid #a7a5a5;
}

.documento_dados .columns .columns {
    padding-right: 7px;
    padding-top: 7px;
    padding-bottom: 7px;
}
.documento_dados:first-of-type {
    word-break: break-word;
}
.documento_dados h3 {
    font-family: "Montserrat";
    font-size: 15px;
    margin-bottom: 0;
    color: #414545;
    padding-right: 20px;
}
.documento_dados .columns:first-of-type .columns:first-of-type h3{
    color: #707475;
    padding-left: 0px;
    font-family: "Montserrat Bold";
}

.documento_dados .columns:last-of-type .columns:last-of-type {
    padding-right: 0!important;
}

.pdf_icon{
    width: 28px;
    margin-right: 24px;
}

.resultados .documento_dados .datacolumn a{
  font-family: "Montserrat";
  font-size: 15px;
  margin-bottom: 14px;
  color: #414545;
  padding-bottom: 0;
  align-items: center;
  display: flex;
}

.resultados .documento_dados .datacolumn a:last-of-type{
    padding-bottom: 0;
    margin-bottom: 0;
}

.anocolumn h3, .descolumn h3{
    padding-top: 7px;
}

.documento_dados_designacao {
    padding-top: 20px;
}

.documento_dados .datacolumn:last-of-type a:hover {
  font-family: "Montserrat SemiBold";
}
/*#endregion*/

@media (max-width: 767px) {
  .resultados .documento_dados .datacolumn a {
    font-size: 13px;
    line-height: 15px;
  }

  .pdf_icon {
    width: 25px;
    margin-right: 15px;
  }

  .icon_erro {
    width: 28px;
  }

  .documento_dados .columns p {
    padding-top: 15px;
    margin-bottom: 0px;
    font-size: 14px;
  }

}
</style>